import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { KnBrCartContextEffects } from './kn-br-cart-context.effects';
import { knBrCartContextReducer } from './kn-br-cart-context.reducer';
import { KN_BR_CONTEXT_CART_FEATURE } from './kn-br-cart-context.state';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(KN_BR_CONTEXT_CART_FEATURE, knBrCartContextReducer),
    EffectsModule.forFeature([KnBrCartContextEffects]),
  ],
})
export class KnBrCartContextStateModule {}
